export default __webpack_public_path__ + "static/media/admin-bg1.c1725dc3.jpg";